import {
  ViewerType,
  viewerTypeToLocalStorageKey,
} from '../constant/viewerConstant';

export function getViewerSettingFromLocalStorage(
  viewerType: ViewerType,
  VIEWER_SETTING_KEY: string
) {
  return window.localStorage.getItem(
    [viewerTypeToLocalStorageKey(viewerType), VIEWER_SETTING_KEY].join('_')
  );
}
